import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { planMutationKeys, planQueryKeys } from '../constants'
import { customQueryClient } from '../../config/query-client'

export const useDeletePlanFolderMutation = (options) => {
  const handleMutation = async ({ folderId = null }) => {
    const config = {
      method: 'delete'
    }

    const { data } = await api(`/api/v2/planFolders/${folderId}`, config)
    return data
  }

  const invalidateRelatedQueries = () => {
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_TREE_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_TREE_INFINITY_QUERY]
    })

    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_CHILDREN_TREE_QUERY]
    })
  }

  return useMutation({
    mutationKey: [planMutationKeys.DELETE_PLAN_FOLDER_MUTATION],
    mutationFn: handleMutation,
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      invalidateRelatedQueries()
      // Call user callback with all original parameters
      options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      // Call user callback with all original parameters
      options?.onError?.(error, variables, context)
    }
  })
}
